import { hasRoleLevel } from './roleUtils';

// This registry owns application routing metadata, not persisted option
// membership. Preference Settings always starts from the database definition's
// allowed_values array and uses this map only to determine whether an allowed
// identifier has a usable route, label, and role policy.
const LAUNCH_PAGE_METADATA = Object.freeze({
  bookings: { path: '/bookings', labelKey: 'bookings', requiredRole: 'user' },
  trips: { path: '/trips', labelKey: 'trips', requiredRole: 'user' },
  // Keep the persisted identifier stable while routing it to the renamed,
  // role-aware Operations page.
  driverdashboard: { path: '/operations', labelKey: 'operations.title', requiredRole: 'driver' },
  vehicles: { path: '/vehicles', labelKey: 'vehicles', requiredRole: 'admin' },
  routes: { path: '/routes', labelKey: 'routes', requiredRole: 'admin' },
  schedules: { path: '/schedule-management', labelKey: 'schedules', requiredRole: 'admin' }
});

export const getLaunchPageOptions = (allowedValues, role) => {
  if (!Array.isArray(allowedValues)) return [];

  const seen = new Set();
  return allowedValues.reduce((options, identifier) => {
    if (typeof identifier !== 'string' || seen.has(identifier)) return options;
    seen.add(identifier);

    const metadata = LAUNCH_PAGE_METADATA[identifier];
    if (!metadata || !hasRoleLevel(role, metadata.requiredRole)) return options;

    options.push({ value: identifier, ...metadata });
    return options;
  }, []);
};

export const resolveLaunchPagePath = (identifier, role) => {
  const metadata = LAUNCH_PAGE_METADATA[identifier];
  if (!metadata || !hasRoleLevel(role, metadata.requiredRole)) {
    return '/bookings';
  }
  return metadata.path;
};

/**
 * Resolve an entity switch from persisted membership provenance. A synthetic
 * catalogue row has no scoped role, so it must deliberately use the user's
 * retained global route role instead of whichever scoped role was active
 * immediately before the switch.
 */
export const resolveSelectedEntityLaunchPath = (entity, globalRouteRole) => {
  const role = entity?.hasActiveMembership === true
    ? entity.membershipRole
    : globalRouteRole;

  return resolveLaunchPagePath(entity?.default_launch_page, role);
};
